import LogoImage from '@/assets/images/logo-with-icon.svg?react'
import DarkLogoImage from '@/assets/images/logo-with-icon-dark.svg?react'
import { useThemeMode } from '@/contexts/ThemeContext'

interface BrandLogoProps {
  width?: number
  height?: number
  className?: string
}

export function BrandLogo({ width = 140, height = 32, className }: BrandLogoProps) {
  const { isDark } = useThemeMode()
  const Logo = isDark ? DarkLogoImage : LogoImage

  return <Logo width={width} height={height} className={className} aria-label="Glows.ai" />
}
